import { AuthException } from 'common/exceptions/http/AuthException';
import AuthInvalidGrantException from 'common/exceptions/http/AuthInvalidGrantException';
import { ConnectionException } from 'common/exceptions/http/ConnectionException';
import { ForbiddenException } from 'common/exceptions/http/ForbiddenException';
import { InternalServerException } from 'common/exceptions/http/InternalServerException';
import { UnknownHttpException } from 'common/exceptions/http/UnknownHttpException';
import { StatusCodes } from 'http-status-codes';
import $ from 'jquery';
import * as UserSettings from './user-settings';

export function post<T>(url: string, body: unknown, cache = false) {
  return new Promise<T>(function (resolve, reject) {
    $.ajax({
      url: url,
      cache: cache,
      type: 'post',
      headers: {
        Authorization: 'bearer ' + UserSettings.getToken(),
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(body),

      success: function (response) {
        resolve(response as T);
      },
      error: function (err) {
        const processedError = processError(err);
        reject(processedError);
      },
    });
  });
}

export function postForm<T>(url: string, body: unknown) {
  return new Promise<T>(function (resolve, reject) {
    $.ajax({
      url: url,
      type: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: body,

      success: function (response) {
        resolve(response as T);
      },
      error: function (err) {
        const processedError = processError(err);
        reject(processedError);
      },
    });
  });
}

export function get<T>(url: string, cache = false) {
  return new Promise<T>(function (resolve, reject) {
    $.ajax({
      url: url,
      type: 'get',
      cache: cache,
      headers: {
        Authorization: 'bearer ' + UserSettings.getToken(),
      },
      success: function (response) {
        resolve(response as T);
      },
      error: function (err) {
        const processedError = processError(err);
        reject(processedError);
      },
    });
  });
}

function processError(httpError: JQuery.jqXHR<unknown>) {
  if (httpError.status === 0) {
    return new ConnectionException(httpError.responseJSON);
  }
  if (httpError.status === StatusCodes.UNAUTHORIZED) {
    return new AuthException(httpError.responseJSON);
  }
  if (httpError.status === StatusCodes.FORBIDDEN) {
    return new ForbiddenException(httpError.responseJSON);
  }
  if (httpError.status === StatusCodes.INTERNAL_SERVER_ERROR) {
    return new InternalServerException(httpError);
  }
  if (
    httpError.status == StatusCodes.BAD_REQUEST &&
    httpError.responseText &&
    httpError.responseText.includes('invalid_grant')
  ) {
    return new AuthInvalidGrantException(httpError);
  }

  return new UnknownHttpException(httpError);
}
